import { render, staticRenderFns } from "./FormLojas.vue?vue&type=template&id=fb334696"
import script from "./FormLojas.vue?vue&type=script&setup=true&lang=ts"
export * from "./FormLojas.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports